export default class Limits {
    constructor() {
        this.pMax = { limit: NaN, enableTrendAlarm: false };
        this.qMax = { limit: NaN, enableTrendAlarm: false };
        this.qMin = { limit: NaN, enableTrendAlarm: false };
        this.uMax = { limit: NaN, enableTrendAlarm: false };
        this.thdMax = { limit: NaN, enableTrendAlarm: false };
        this.unbMax = { limit: NaN, enableTrendAlarm: false };
    }
}
